'use strict';

import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import { createComponentVNode } from "inferno";
import { Component } from 'inferno';
import { renderString, renderVariables } from './widgets/common';
import { i18n } from 'isomorphic-schema';
import _bs_Label from 'inferno-bootstrap/lib/Form/Label';
import FormText from 'inferno-bootstrap/lib/Form/FormText';
import FormFeedback from 'inferno-bootstrap/lib/Form/FormFeedback';
import { findDOMNode } from 'inferno-extras';
import { animateOnAdd, animateOnRemove } from 'inferno-animation';
/*

    Components and helper functions for sending feedback to user about validation errors.

*/

function Label(props) {
  return createComponentVNode(2, _bs_Label, {
    "id": props.id,
    children: renderString(props.children, props.options && props.options.lang)
  });
}

function HelpMsg(_ref, context) {
  var field = _ref.field,
      text = _ref.text,
      id = _ref.id,
      required = _ref.required,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? {} : _ref$options; // don't render if nothing to show

  if (!text && !required) return null;
  var outp = [];
  if (text) outp.push(renderVariables(field, renderString(text, options.lang)));
  if (required) outp.push(renderVariables(field, renderString(i18n('isomorphic-schema--field_required', '(required)'), options.lang, '(required)')));

  if (context && context.renderHelpAsHtml) {
    return createComponentVNode(2, FormText, {
      "className": "text-muted",
      "for": id,
      "dangerouslySetInnerHTML": {
        __html: outp.join(' ')
      }
    });
  } else {
    return createComponentVNode(2, FormText, {
      "className": "text-muted",
      "for": id,
      children: outp.join(' ')
    });
  }
}

function unpackInvariantErrors(validationError, namespace) {
  if (validationError === undefined) return;
  var invariantError;

  if (Array.isArray(validationError.invariantErrors)) {
    var dotName = namespace.join('.');
    var tmpInvErrs = validationError.invariantErrors.filter(function (invErr) {
      // Pattern match field name of error with current namespace to see if it is a match
      return invErr.fields.reduce(function (prev, curr) {
        return prev || curr === dotName;
      }, false);
    });

    if (tmpInvErrs.length > 1) {
      invariantError = {
        message: 'There are several form value errors here',
        i18nLabel: 'inferno-formlib--multiple_invariant_errors'
      };
    } else {
      invariantError = tmpInvErrs[0];
    }
  }

  return invariantError;
}

var ErrorMsg = /*#__PURE__*/function (_Component) {
  _inherits(ErrorMsg, _Component);

  function ErrorMsg() {
    _classCallCheck(this, ErrorMsg);

    return _possibleConstructorReturn(this, _getPrototypeOf(ErrorMsg).apply(this, arguments));
  }

  _createClass(ErrorMsg, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      animateOnAdd(findDOMNode(this), 'InfernoFormlib-ErrorMsg--Animation');
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      animateOnRemove(findDOMNode(this), 'InfernoFormlib-ErrorMsg--Animation');
    }
  }, {
    key: "render",
    value: function render(_ref2) {
      var field = _ref2.field,
          validationError = _ref2.validationError,
          _ref2$options = _ref2.options,
          options = _ref2$options === void 0 ? {} : _ref2$options;
      return createComponentVNode(2, FormFeedback, {
        children: renderVariables(field, renderString(validationError.i18nLabel, options.lang, validationError.message))
      });
    }
  }]);

  return ErrorMsg;
}(Component);

export { Label, ErrorMsg, HelpMsg, unpackInvariantErrors };